/** Collect mammoth block elements in document order (matches w:p sequence). */
export function collectImportBlockElements(root: ParentNode): HTMLElement[] {
  const blocks: HTMLElement[] = [];

  function walk(node: Node): void {
    if (!(node instanceof HTMLElement)) return;

    const tag = node.tagName;
    if (tag === "P" || /^H[1-6]$/.test(tag)) {
      blocks.push(node);
      return;
    }
    if (tag === "LI") {
      blocks.push(node);
      return;
    }

    for (let i = 0; i < node.childNodes.length; i++) {
      walk(node.childNodes[i]);
    }
  }

  walk(root);
  return blocks;
}

export function escapeHtml(text: string): string {
  return text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}
